import script from "./BaseTeamCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./BaseTeamCarousel.vue?vue&type=script&setup=true&lang=js"

import "./BaseTeamCarousel.vue?vue&type=style&index=0&id=41046e6c&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-41046e6c"]])

export default __exports__